import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { fb } from "../firebase.config";
import useWebPushNotifications from "./useWebPushNotifications";

interface Props {
  userId: string;
  setNotificationBadge?: Dispatch<SetStateAction<boolean>>;
}

export const useFCMNotifications = (props: Props) => {
  const { userId, setNotificationBadge = () => null } = props;

  const [notification, setNotification] = useState(null);

  const { doesBrowserSupportsPush } = useWebPushNotifications(userId);

  useEffect(() => {
    if (typeof window !== "undefined" && window?.["isRenderedInWebView"])
      return;

    const isPushSupported = doesBrowserSupportsPush();
    if (!isPushSupported) return;

    // Handle notifications if the app is foregrounded
    fb?.messaging()?.onMessage((payload) => {
      const { notification } = payload;

      setNotification(notification);
      setNotificationBadge(true);
    });
  }, [doesBrowserSupportsPush, setNotificationBadge]);

  return {
    notification,
  };
};
